import { Box, Flex, Heading, Icon, Link as ChakraLink, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { MdEmail, MdLock } from "react-icons/md";

const Contacts = () => {
  return (
    <Box bg="white" py={[8, 12]} px={[4, 6, 8]}>
      <Box maxW="1400px" mx="auto">
        <Heading
          fontSize={["1.6rem", "2rem"]}
          color="green.700"
          mb={1}
          borderLeft="4px solid"
          borderColor="green.400"
          pl={4}
        >
          Contatos
        </Heading>
        <Box w="60px" h="3px" bg="green.400" ml={4} mb={8} borderRadius="2px" />

        <Flex flexDir={["column", "row"]} gap={[4, 8]}>
          <Flex
            alignItems="center"
            gap={3}
            bg="green.50"
            px={5}
            py={4}
            borderRadius="0.75rem"
            border="1px solid"
            borderColor="green.100"
          >
            <Icon as={MdEmail} color="green.500" boxSize={5} />
            <ChakraLink href="mailto:contato@acaol.org" color="green.700" fontWeight={600} fontSize="1rem">
              contato@acaol.org
            </ChakraLink>
          </Flex>

          <Flex
            alignItems="center"
            gap={3}
            bg="gray.50"
            px={5}
            py={4}
            borderRadius="0.75rem"
            border="1px solid"
            borderColor="gray.100"
          >
            <Icon as={MdLock} color="gray.400" boxSize={5} />
            <Link to="/privacy">
              <Text color="gray.600" fontWeight={600} fontSize="1rem" _hover={{ color: "green.600" }}>
                Declaração de privacidade e dados
              </Text>
            </Link>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};
export default Contacts;
